import ErrorMsg from '@components/error/ErrorMsg';
import { useRouter } from 'next/router';
import React, { useCallback } from 'react';
import { useTranslation } from 'next-i18next';
import { ErrorPageType } from '@src/common/enums';
import { hideLoading, removeCIDUrl } from '@src/utils/util';
import DefaultPage from '@src/pages/share/defaultPage';
import { ContentBlockFragment } from '@graphqlTypes/sitecore';

type ErrorHandlerProps = {
    errorPageType?: ErrorPageType;
    contentBlockData?: ContentBlockFragment;
};

export const ErrorHandler = ({ errorPageType, contentBlockData }: ErrorHandlerProps) => {
    const router = useRouter();
    const { t } = useTranslation();
    hideLoading();

    const reload = useCallback(() => {
        router.reload();
    }, [router]);
    const goHome = useCallback(() => {
        router.push(removeCIDUrl(`/${location.search}`));
    }, [router]);
    let renderedError = <></>;
    switch (errorPageType) {
        case ErrorPageType.noaccess:
            renderedError = (
                <ErrorMsg
                    onRetry={goHome}
                    retryText={t('errorMsg.viewMore').toString()}
                    msg={t('errorMsg.notAvailableForCustomer').toString()}
                ></ErrorMsg>
            );
            break;
        case ErrorPageType.nolocale:
            renderedError = (
                <ErrorMsg
                    onRetry={goHome}
                    retryText={t('errorMsg.backToMain').toString()}
                    msg={t('errorMsg.notAvailableForLanguage').toString()}
                ></ErrorMsg>
            );
            break;
        case ErrorPageType.notFound:
            renderedError = (
                <ErrorMsg
                    onRetry={goHome}
                    retryText={t('errorMsg.backToMain').toString()}
                ></ErrorMsg>
            );
            break;
        case ErrorPageType.unPublished:
            renderedError = (
                <ErrorMsg
                    onRetry={goHome}
                    msg={t('errorMsg.unPublished').toString()}
                    retryText={t('errorMsg.backtoHome').toString()}
                ></ErrorMsg>
            );
            break;
        case ErrorPageType.noSharePage:
            renderedError = <DefaultPage contentBlock={contentBlockData}></DefaultPage>;
            break;
        default:
            renderedError = <ErrorMsg onRetry={reload}></ErrorMsg>;
            break;
    }

    return (
        <div className='bg-[#F6F7F8] w-[100vw] h-[100vh] flex justify-center items-center'>
            <div className={`relative ${!ErrorPageType.noSharePage ? 'bottom-16' : ''}`}>
                {renderedError}
            </div>
        </div>
    );
};

export default ErrorHandler;
